import { Button, Col, Modal, Popconfirm, Row } from 'antd'
import React, { Component } from 'react'
import BillLineForm from './BillLineForm'

class BillLineModal extends Component {
  render() {
    const {
      visibleBillLine,
      onCancelBillLine,
      submittingLine,
      removingLine,
      billLineModalType,
      billLineFormRef,
      isUpdatable,
      addLine,
      updateLine,
      removeLine,
      invoice,
    } = this.props

    const isConfirmed = ['Confirmed'].includes(invoice.status)
    return (
      <Modal
        visible={visibleBillLine}
        title={billLineModalType !== 'edit' ? 'Add Bill Line' : `Update Bill Line`}
        onCancel={onCancelBillLine}
        destroyOnClose={true}
        width={'95%'}
        footer={
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              {billLineModalType === 'edit' && !isConfirmed && (
                <Popconfirm
                  title="Are you sure remove this bill line?"
                  onConfirm={removeLine}
                  okText="Yes"
                  cancelText="No">
                  <Button type="danger" loading={removingLine} style={{ marginLeft: 8 }}>
                    Remove
                  </Button>
                </Popconfirm>
              )}
              <Button
                loading={submittingLine}
                type="primary"
                onClick={billLineModalType === 'new' ? addLine : updateLine}>
                {billLineModalType === 'new' ? 'Create' : 'Update'}
              </Button>
            </Col>
          </Row>
        }>
        <Row>
          <BillLineForm {...this.props} ref={billLineFormRef} />
        </Row>
      </Modal>
    )
  }
}

BillLineModal.propTypes = {}
BillLineModal.defaultProps = { billLineModalType: 'new' }

export default BillLineModal
